/* eslint @typescript-eslint/ban-ts-comment: 0 */

import { createStore, applyMiddleware, compose } from 'redux'
import { createEpicMiddleware } from 'redux-observable'
import thunk from 'redux-thunk'
import reducers from './reducers'
import APIGateway from '../services/apiGateway'
import twilioVideoConnect from '../services/video'
import disconnectRoom from '../lib/disconnectRoom'
import { SyncClient } from 'twilio-sync'
import getVideoConstraints from '../lib/getVideoConstraints'
import getDeadMansHandleStatus from '../lib/getDeadMansHandleStatus'
import isScreenshareTrack from '../lib/isScreenshareTrack'
import checkRoomAvailability from '../lib/checkRoomAvailability'
import usernameLib from '../lib/username'
import getPresenterCount from '../lib/getPresenterCount'
import twilioSyncConnect from '../services/sync'
import checkQuestionsPollStatus from '../lib/checkQuestionsPollStatus'
import getUpdatedValues from '../lib/getUpdatedValues'
import trackActions from './actions/tracks'
import setParticipantInformation from '../lib/setParticipantInformation'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose
  }
}

// @ts-ignore
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ maxAge: 100 }) : compose

export const epicMiddleware = createEpicMiddleware({
  dependencies: {
    twilioVideoConnect,
    APIGateway,
    disconnectRoom,
    SyncClient,
    getVideoConstraints,
    getDeadMansHandleStatus,
    isScreenshareTrack,
    trackActions,
    usernameLib,
    getPresenterCount,
    checkRoomAvailability,
    twilioSyncConnect,
    getUpdatedValues,
    checkQuestionsPollStatus,
    setParticipantInformation
  }
})

const store = createStore(
  reducers,
  composeEnhancer(
    applyMiddleware(
      epicMiddleware,
      thunk
    )
  )
)

export const storeDispatch = store.dispatch

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export default store
